webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hello',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js PWA'
    };
  }
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__ = __webpack_require__(22);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PricingCalculator',
  data: function data() {
    return {
      pricingTable: __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["b" /* PricingTable */],
      pricingSetting: __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */],
      pricingData: {},
      numOfUsers: null,
      numOfPush: null,
      numOfTotalMsg: null,
      lowPrice: 0,
      mediumPrice: 0,
      highPrice: 0,
      bestChoice: "",
      bestPlanName: "",
      bestPrice: 0,
      bestSave: 0,
      lowPriceData: [{ 'type': "固定月費", 'amount': __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].low.basicPrice }, { 'type': "訊息加購費", 'amount': this.lowPrice }, { 'type': "小計(未稅)", 'amount': __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].low.basicPrice }, { 'type': "含稅價", 'amount': __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].low.basicPrice }],
      columns: [{
        field: 'type',
        label: '類別'
      }, {
        field: 'amount',
        label: '金額',
        numeric: true
      }],
      creditActive: false
    };
  },

  computed: {
    // numOfTotalMsg: {
    //   get () {
    //     if (this.numOfUsers == null || this.numOfPush == null) {
    //       return 0
    //     }
    //     return this.numOfUsers * this.numOfPush
    //   },
    //   set (value) {
    //     if (this.numOfUsers > 0) {
    //       this.numOfPush = value / this.numOfUsers
    //     } 

    //   }
    // }
  },
  watch: {
    numOfTotalMsg: function numOfTotalMsg(value) {
      this.getPricing();
    },
    numOfUsers: function numOfUsers(value) {
      this.numOfTotalMsg = value * this.numOfPush;
    },
    numOfPush: function numOfPush(value) {
      this.numOfTotalMsg = this.numOfUsers * value;
    }
  },
  methods: {

    getPricing: function getPricing() {
      // console.log('getPricing');

      this.mediumPrice = this.getMediumMsgPrice();
      this.highPrice = this.getHighMsgPrice();

      if (this.numOfTotalMsg <= 500) {
        this.bestChoice = 'low';
      } else {
        var highTotalPrice = (__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.basicPrice + this.highPrice) * 1.05;
        var mediumTotalPrice = (__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].medium.basicPrice + this.mediumPrice) * 1.05;
        if (highTotalPrice < mediumTotalPrice) {
          this.bestChoice = 'high';
          this.bestPlanName = "高用量";
          this.bestPrice = highTotalPrice;
          this.bestSave = mediumTotalPrice - highTotalPrice;
        } else {
          this.bestChoice = 'medium';
          this.bestPlanName = "中用量";
          this.bestPrice = mediumTotalPrice;
          this.bestSave = highTotalPrice - mediumTotalPrice;
        }
      }

      this.mediumPriceData = [{ 'type': "固定月費", 'amount': numeral(__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].medium.basicPrice).format('0,0') }, { 'type': "訊息加購費", 'amount': numeral(this.mediumPrice).format('0,0') }, { 'type': "小計(未稅)", 'amount': numeral(__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].medium.basicPrice + this.mediumPrice).format('0,0') }, { 'type': "含稅價", 'amount': numeral((__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].medium.basicPrice + this.mediumPrice) * 1.05).format('0,0') }];

      this.highPriceData = [{ 'type': "固定月費", 'amount': numeral(__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.basicPrice).format('0,0') }, { 'type': "訊息加購費", 'amount': numeral(this.highPrice).format('0,0') }, { 'type': "小計(未稅)", 'amount': numeral(__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.basicPrice + this.highPrice).format('0,0') }, { 'type': "含稅價", 'amount': numeral((__WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.basicPrice + this.highPrice) * 1.05).format('0,0') }];
    },

    getMediumMsgPrice: function getMediumMsgPrice() {
      if (this.numOfTotalMsg <= 4000) {
        return 0;
      } else {
        var amount = this.numOfTotalMsg - 4000;
        return amount * 0.2;
      }
    },

    getHighMsgPrice: function getHighMsgPrice() {
      // console.log(this.numOfTotalMsg)
      var tier = 0;
      var price = 0;
      if (this.numOfTotalMsg <= __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.freeQuota) {
        return price;
      }
      var numOfRemaining = this.numOfTotalMsg;
      numOfRemaining -= __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.freeQuota;

      while (numOfRemaining > 0) {
        // console.log("tier: " + tier + ", remaing: " + numOfRemaining);
        // console.log(numOfRemaining)
        var numOfConsumed = 0;

        if (numOfRemaining - this.pricingTable[tier][0] <= 0) {
          numOfConsumed = numOfRemaining;
          numOfRemaining = numOfRemaining - this.pricingTable[tier][0];
        } else {
          numOfConsumed = this.pricingTable[tier][0];
          numOfRemaining = numOfRemaining - this.pricingTable[tier][0];
        }
        // console.log(numOfConsumed);
        // console.log(this.pricingTable[tier][1]);

        price += numOfConsumed * this.pricingTable[tier][1];
        tier += 1;
        if (tier > __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.tiers) {
          // console.log('over!!')
          // console.log("numOfRemaining: " + numOfRemaining)
          // console.log("additional price: " + numOfRemaining * PricingSetting.high.addictionTop)
          price += numOfRemaining * __WEBPACK_IMPORTED_MODULE_0__pricingTable_js__["a" /* PricingSetting */].high.addictionTop;
          break;
        }
        // console.log('current Price: ' + price)
      }
      return price;
    }

  },
  mounted: function mounted() {
    console.log(this.$route.query);
    if (this.$route.query.users) {
      this.numOfUsers = this.$route.query.users;
    }

    if (this.$route.query.push) {
      this.numOfPush = this.$route.query.push;
    }
  }

});

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_buefy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_buefy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_min_css__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buefy_dist_buefy_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_numeral_filter__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_analytics__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_buefy___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_numeral_filter__["a" /* default */], { locale: 'en-gb' });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_analytics___default.a, {
  id: 'UA-138741355-1',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(3);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97bbf012_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(14);
function injectStyle (ssrContext) {
  __webpack_require__(12)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97bbf012_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_vm._v(" "),_c('main',[_c('router-view')],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('span',[_vm._v("\n      Line官方帳號2.0計算機\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PricingCalculator__ = __webpack_require__(20);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_3__components_PricingCalculator__["a" /* default */]
  }]
}));

/***/ }),
/* 16 */,
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(4);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f08b3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(19);
function injectStyle (ssrContext) {
  __webpack_require__(18)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7f08b3c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 18 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('h2',[_vm._v("Essential Links")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('h2',[_vm._v("Ecosystem")]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"https://vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Core Docs")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://forum.vuejs.org","target":"_blank","rel":"noopener"}},[_vm._v("Forum")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://chat.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("Vue Community Chat")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://twitter.com/vuejs","target":"_blank","rel":"noopener"}},[_vm._v("Twitter")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuejs-templates.github.io/webpack/","target":"_blank","rel":"noopener"}},[_vm._v("Docs for This Template")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_c('a',{attrs:{"href":"http://router.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-router")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vuex.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vuex")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"http://vue-loader.vuejs.org/","target":"_blank","rel":"noopener"}},[_vm._v("vue-loader")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://github.com/vuejs/awesome-vue","target":"_blank","rel":"noopener"}},[_vm._v("awesome-vue")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingCalculator_vue__ = __webpack_require__(5);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74250366_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingCalculator_vue__ = __webpack_require__(23);
function injectStyle (ssrContext) {
  __webpack_require__(21)
}
var normalizeComponent = __webpack_require__(2)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PricingCalculator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74250366_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PricingCalculator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PricingTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PricingSetting; });
var PricingTable = [[10000, 0.15], [10000, 0.14], [20000, 0.13], [40000, 0.12], [80000, 0.11], [160000, 0.095], [320000, 0.094], [160000, 0.090], [480000, 0.086], [1280000, 0.078], [940000, 0.07], [1620000, 0.06], [2880000, 0.05], [2240000, 0.035], [10240000, 0.017]];

// export const PricingSetting = {
//     mediumBasic: 800,
//     mediumAddiction: 0.2,

//     highBasic: 4000,
//     highFreeQuota: 25000
// }

var PricingSetting = {
    low: {
        basicPrice: 0,
        freeQuota: 500
    },
    medium: {
        basicPrice: 800,
        addictionPrice: 0.2,
        freeQuota: 4000
    },
    high: {
        basicPrice: 4000,
        freeQuota: 25000,
        addictionTop: 0.01,
        tiers: 14
    }

};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column"},[_c('div',[_c('h1',{staticClass:"method-title"},[_vm._v("方法A：人數預估法")]),_vm._v(" "),_c('b-field',{attrs:{"label":"粉絲人數"}},[_c('b-input',{attrs:{"rounded":"","icon":"user","type":"number","min":"0","placeholder":"請輸入官方帳號的粉絲人數"},model:{value:(_vm.numOfUsers),callback:function ($$v) {_vm.numOfUsers=$$v},expression:"numOfUsers"}})],1),_vm._v(" "),_c('b-field',{attrs:{"label":"預計每人推播訊息數"}},[_c('b-input',{attrs:{"rounded":"","type":"number","min":"0","placeholder":"請輸入本月預計要推幾次訊息"},model:{value:(_vm.numOfPush),callback:function ($$v) {_vm.numOfPush=$$v},expression:"numOfPush"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"column",staticStyle:{"border-left":"2px dotted #00b800"}},[_c('h1',{staticClass:"method-title"},[_vm._v("方法B：總訊息預估法")]),_vm._v(" "),_c('b-field',{attrs:{"label":"每月訊息總數"}},[_c('b-input',{attrs:{"rounded":"","type":"number","min":"0","placeholder":"請輸入預計發送的訊息總數"},model:{value:(_vm.numOfTotalMsg),callback:function ($$v) {_vm.numOfTotalMsg=$$v},expression:"numOfTotalMsg"}})],1)],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.bestChoice)?_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"card",class:{'bestChoice': _vm.bestChoice == 'low'}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('figure',{staticClass:"image is-48x48"},[(_vm.bestChoice == 'low')?_c('b-icon',{attrs:{"icon":"check","size":"is-large","type":"is-success"}}):_c('b-icon',{attrs:{"icon":"minus-circle","size":"is-large"}})],1)]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("免費訊息數量："+_vm._s(_vm._f("numeral")(_vm.pricingSetting.low.freeQuota,'0,0'))+"則")]),_vm._v(" "),_c('p',[_vm._v("每則加購費用：不可加購")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('b-table',{attrs:{"data":_vm.lowPriceData,"columns":_vm.columns}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"card",class:{'bestChoice': _vm.bestChoice == 'medium'}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('figure',{staticClass:"image is-48x48"},[(_vm.bestChoice == 'medium')?_c('b-icon',{attrs:{"icon":"check","size":"is-large","type":"is-success"}}):_c('b-icon',{attrs:{"icon":"minus-circle","size":"is-large"}})],1)]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("免費訊息數量："+_vm._s(_vm._f("numeral")(_vm.pricingSetting.medium.freeQuota,'0,0'))+"則")]),_vm._v(" "),_c('p',[_vm._v("每則訊息費用："+_vm._s(_vm.pricingSetting.medium.addictionPrice)+"元")]),_vm._v(" "),_c('p',[_vm._v(" ")]),_vm._v(" "),_c('b-table',{attrs:{"data":_vm.mediumPriceData,"columns":_vm.columns}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"column"},[_c('div',{staticClass:"card",class:{'bestChoice': _vm.bestChoice == 'high'}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"media"},[_c('div',{staticClass:"media-left"},[_c('figure',{staticClass:"image is-48x48"},[(_vm.bestChoice == 'high')?_c('b-icon',{attrs:{"icon":"check","size":"is-large","type":"is-success"}}):_c('b-icon',{attrs:{"icon":"minus-circle","size":"is-large"}})],1)]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('p',[_vm._v("免費訊息數量："+_vm._s(_vm._f("numeral")(_vm.pricingSetting.high.freeQuota,'0,0'))+"則")]),_vm._v(" "),_c('p',[_vm._v("每則加購費用：0.15~")]),_vm._v(" "),_c('p',[_vm._v("(依級距調整)")]),_vm._v(" "),_c('b-table',{attrs:{"data":_vm.highPriceData,"columns":_vm.columns}})],1)])])])]):_vm._e(),_vm._v(" "),(_vm.bestChoice)?_c('section',{staticClass:"hero is-success"},[_c('div',{staticClass:"hero-body"},[(_vm.bestChoice != 'low')?_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("\n          預估花費(含稅)："+_vm._s(_vm._f("numeral")(_vm.bestPrice,'0,0'))+"\n        ")]),_vm._v(" "),_c('h2',{staticClass:"subtitle"},[_vm._v("\n          相較其他方案，選擇『"+_vm._s(_vm.bestPlanName)+"』方案，可以省下　"+_vm._s(_vm._f("numeral")(_vm.bestSave,'0,0'))+"\n        ")]),_vm._v(" "),_c('a',{staticClass:"button  is-inverted is-outlined is-medium",attrs:{"href":"https://lychee.tw/nice-push.html?utm_source=calculator","target":"_blank"}},[_vm._v("想要省更多？試試荔枝好推")]),_vm._v(" "),_c('br')]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('br'),_c('br'),_c('br'),_vm._v(" "),_c('button',{staticClass:"button is-text is-pulled-right",on:{"click":function($event){_vm.creditActive = true}}},[_vm._v("\n    其他\n  ")]),_vm._v(" "),_c('a',{staticClass:"button is-text is-pulled-right",attrs:{"target":"_blank","href":"https://bit.ly/2VXt1y4"}},[_vm._v("\n    有話想說\n  ")]),_vm._v(" "),_c('b-modal',{attrs:{"active":_vm.creditActive},on:{"update:active":function($event){_vm.creditActive=$event}}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"content"},[_c('h4',[_vm._v("資料來源")]),_vm._v("\n            計費標準參照Line官方部落格\n            "),_c('a',{attrs:{"href":"http://at-blog.line.me/tw/archives/LINEOA2.0.html"}},[_vm._v("http://at-blog.line.me/")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('h4',[_vm._v("credits")]),_vm._v("\n              Icons made by\n            "),_c('a',{attrs:{"href":"https://www.freepik.com/","title":"Freepik","target":"_blank"}},[_vm._v("Freepik")]),_vm._v(" from\n            "),_c('a',{attrs:{"href":"https://www.flaticon.com/","title":"Flaticon","target":"_blank"}},[_vm._v("www.flaticon.com")]),_vm._v(" is licensed by\n            "),_c('a',{attrs:{"href":"http://creativecommons.org/licenses/by/3.0/","title":"Creative Commons BY 3.0","target":"_blank"}},[_vm._v("CC 3.0 BY")])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-content"},[_c('p',{staticClass:"title is-2"},[_vm._v("低用量")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-content"},[_c('p',{staticClass:"title is-2"},[_vm._v("中用量")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media-content"},[_c('p',{staticClass:"title is-2"},[_vm._v("高用量")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[7]);


// WEBPACK FOOTER //
// static/js/app.473e678e34555d599a40.js